import { orderBy } from 'lodash';
import BaseModel from '@/shared/models/BaseModel';
import { isPresent } from '@/shared/utils/typescript';
import ChatMessage from './ChatMessage';
import { ChatId } from './ids';

export default class Chat extends BaseModel<ChatId> {
  origin = '';
  unreadMessages = 0;
  messages: Array<ChatMessage> = [];

  constructor(id: ChatId | null = null) {
    super();
    this.id = id;
  }

  orderMessages(): void {
    this.messages = orderBy(this.messages, m => m.createdOn?.valueOf(), 'asc');
  }

  async preloadMediaThumbnails(): Promise<void> {
    await Promise.allSettled(this.messages.map(m => m.preloadMediaThumbnail()));
  }

  addMessage(message: ChatMessage): void {
    if (!isPresent(this.id)) this.id = message.chatId;
    if (this.id === message.chatId && !this.messages.some(m => m.id === message.id)) {
      this.messages.push(message);
    }
  }
}
